module.exports = __webpack_public_path__ + "static/media/medida.04b7f85b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/medida.svg
// module id = 107
// module chunks = 0